import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from './style';

type Props = {
  pricing: string;
  shippingAddress: string;
};

const CostAndShipping = ({ pricing, shippingAddress }: Props) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        COST & SHIPPING
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title">Pricing :</Typography>
          <Typography className="value">{pricing}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title">Shipping Address :</Typography>
          <Typography className="value">{shippingAddress}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default CostAndShipping;
